import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>Contact us at: jahnassociates19@gmail.com</p>
      <p>© 2025 JAHN ASSOCIATES. All rights reserved.</p>
    </footer>
  );
};

export default Footer;